module.exports = __webpack_public_path__ + "img/bg_partner.1768119790257.png";